/**
 * 自动领取会员
 */
import React from 'react'
import { useModalWrap } from '@/components'
import Body from './Body'

const useMemberAutoReceive = ({ updateMemberShow }: any) => {
  const { showModal, render } = useModalWrap({
    modalProps: {
      title: null,
      width: 525,
      bodyStyle: { padding: 0 },
      footer: null,
      // closable:false
      afterClose: () =>  updateMemberShow?.(0),
    },
    children: ({ hideModal }: any) => <Body onClose={hideModal} />,
  })

  const show = () => {
    updateMemberShow?.(1)
    showModal()
  }

  return {
    showModal: show,
    render,
  }
}

export default useMemberAutoReceive
